module.exports = __webpack_public_path__ + "static/media/logo_latam.f983ea84.png";